import { render, staticRenderFns } from "./DepartmentViewPage.vue?vue&type=template&id=f43f6056&"
import script from "./DepartmentViewPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports